import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateInThePastValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const date = new Date(value);
    date.setHours(0, 0, 0, 0);
    if (isNaN(date.getTime())) {
      return { dateOutOfRange: true };
    }


    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (date < today) {
      return { dateOutOfRange: true };
    }

    return null;
  };
}

export function dateAtLeastSevenDaysInTheFutureValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const date = new Date(value);
    date.setHours(0, 0, 0, 0);
    if (isNaN(date.getTime())) {
      return { dateOutOfRange: true };
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const nextWeek = new Date(today);
    nextWeek.setDate(today.getDate() + 7);

    if (date < nextWeek) {
      return { dateOutOfRange: true };
    }

    return null;
  };
}
